//@ts-check
import {
  readB2bVariantPricing,
  updateB2bQuantityPricing,
} from './js-utils-b2b-quantity-pricing.js'

class CPanel extends HTMLElement {
  constructor() {
    super()
    this.allToggleBtn = [
      ...document.querySelectorAll(`[data-toggle-panel="${this.id}"]`),
    ]
    /** @type {HTMLButtonElement|null} */
    this.trapFocusBtn = document.querySelector(
      `[data-close-trap-focus="${this.id}"]`
    )
    this.btnProductStickyMobile = document.querySelector(
      '.product-btn-sticky.v-mobile'
    )?.parentElement
  }

  connectedCallback() {
    this.allToggleBtn.forEach((btn) => {
      btn.addEventListener('click', () => this.togglePanel())
    })
  }
  static get observedAttributes() {
    return ['product-was-add']
  }

  /**
   *
   * @param {string} name
   * @param {string} oldValue
   * @param {string} newValue
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'product-was-add' && newValue == 'true') {
      this.togglePanel()
    }
    // called when one of attributes listed above is modified
  }
  togglePanel() {
    const isOpening = !this.classList.contains('is-open')

    if (isOpening) {
      if (this.dataset.type === 'product-form') {
        // @ts-ignore
        if (window.dataLayer != undefined) {
          // @ts-ignore
          window.dataLayer.push({ event: 'display_product-form' })
        }

        if (readB2bVariantPricing()) {
          updateB2bQuantityPricing()
        } else {
          /** @type {HTMLElement|null} */
          const basePrice = this.querySelector('[data-base-price]')
          /** @type {HTMLElement|null} */
          const priceDisplay = this.querySelector('[data-price]')
          /** @type {HTMLInputElement|null} */
          const quantityInput = document.querySelector('[data-input-quantity]')

          if (basePrice && priceDisplay && quantityInput) {
            const unitPrice = parseFloat(basePrice.dataset.basePrice || '0')
            const quantity = parseInt(quantityInput.value, 10)
            priceDisplay.textContent = String(quantity * unitPrice)
          }
        }
      }
      if (this.id === 'panel-cart') {
        // @ts-ignore
        if (window.dataLayer != undefined) {
          // @ts-ignore
          window.dataLayer.push({ event: 'display_cart' })
        }
      }
    }

    this.classList.toggle('is-open')
    this.trapFocusBtn?.focus()

    this.updateOpenPanelCount(isOpening ? 1 : -1)
    this.updateDocumentState()
  }

  /**
   * @param {number} delta .
   */
  updateOpenPanelCount(delta) {
    const currentCount = this.getOpenPanelCount()
    const newCount = Math.max(0, currentCount + delta)
    document.documentElement.setAttribute('nbr-open-panel', `${newCount}`)
  }

  getOpenPanelCount() {
    return parseInt(
      document.documentElement.getAttribute('nbr-open-panel') || '0'
    )
  }

  updateDocumentState() {
    const hasOpenPanels = this.getOpenPanelCount() > 0

    document.documentElement.classList.toggle(
      'is-overflow-hidden',
      hasOpenPanels
    )
    this.btnProductStickyMobile?.classList.toggle('is-hide', hasOpenPanels)
  }
  disconnectedCallback() {
    this.allToggleBtn.forEach((btn) => {
      btn.removeEventListener('click', () => this.togglePanel())
    })
  }
}
if (!customElements.get('c-panel')) {
  customElements.define('c-panel', CPanel)
}
